import { useTranslation } from "react-i18next";

const Trans = (string) => {
  const { t } = useTranslation();
  const ret = t(string);
  return ret;
};

export default Trans;
